import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { showSnackbar } from '../../../api/snackbarSlice';
import { reconClient } from '../../../utils/axios';

// POST /api/v1/uploads?side=erp — multipart file; 202 with the session row.
// ERP side only: the Marmin/compliance side is fed by the backend's ClickHouse
// sync, never uploaded from this UI.
export const createUpload = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  const { data } = await reconClient.post('/uploads', formData, {
    params: { side: 'erp' },
    headers: { 'Content-Type': 'multipart/form-data' },
    skipErrorSnackbar: true,
  });
  return data;
};

export const useCreateUploadHandler = ({ onSuccess } = {}) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  const { mutate, isPending } = useMutation({
    mutationFn: createUpload,
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['recon-uploads'] });
      onSuccess?.(data);
    },
    onError: (error) => {
      const message = error?.response?.data?.detail ?? error?.message ?? 'Failed to upload file';
      dispatch(showSnackbar({ message, severity: 'error' }));
    },
  });

  return { onUpload: mutate, isPending };
};
